//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import { Helmet } from 'react-helmet';
import $ from "jquery";
import moment from 'moment';
import dateFormat from 'dateformat';

//components
import Lista from '../childrens/lista/.mixins/Lista';
import Alerta from "../../../../../util/snackbars/.mixins/";
import ModalRemove from "../childrens/modal_remove/.mixins/Modal_Remove";
import CustomToolbar from '../childrens/customToolbar/.mixins';
import CustomToolbarSelect from '../childrens/customToolbarSelect/.mixins';
import { Columns } from '../childrens/columns/.mixins';
import Modal from '../childrens/modal/.mixins';
import DialogConfirmRemove from '../childrens/dialogConfirmRemove/.mixins';
import { DialogConfirm } from 'components/util/dialogConfirm';

// import TagManager from 'react-gtm-module';
import { AuthContext } from '../../../../../../contexts/AuthContext';

//constrollers
import Compliance_controller from '../../../../../../controllers/compliance';
import Config from '../../../../../../controllers/config';
import Log from '../../../../../../controllers/log';

export default class Compliance extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.child = React.createRef();
    this.inputRef = React.createRef();
    this.permissions = {};

    this.state = {
      itens: [],
      itensTable: [],
      title: "Compliance",
      pendingList: [],
      columns: [],
      documentId: 0,
      openConfirm: false,
      customToolbar: null,
      customToolbarSelect: null,
      isLoading: true,
      isError: false,
      error: null,
      openModel: false,
      selectableRows: false,
      open: false,
      id: null,
      titulo: '',
      descricao: '',
      lancamento: new Date(),
      termino: new Date(),
      arquivo: '',
      arquivoName: '',
      arquivoIndicacao: null,
      arquivoIndicacaoNome: null,
      arquivoIndicacaoDisplay: true,
      arquivoTipo: '',
      arquivoExtensao: '',
      editFileMode: false,
      tipo: 'Adicionar'
    }

    //binds
    this.setState = this.setState.bind(this);
    this.handleOpenModel = this.handleOpenModel.bind(this);
    this.handleCloseModel = this.handleCloseModel.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.sendForm = this.sendForm.bind(this);

  }

  componentDidMount() {
    // TagManager.dataLayer({
    //     dataLayer: {
    //       event: 'event',
    //       eventCategory: 'tokstok:fornecedores:compliance',
    //       eventAction: 'componentDidMount',
    //       eventLabel: 'componente-compliance',
    //     }
    // });

    //auditoria
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    Log.info(token, "Efetuado carregamento da tela lista de grupos!");

    $(document).ready(() => {
      setTimeout(() => {
        $($("tbody")).css('cursor', 'pointer');
      }, 2000);
      setTimeout(() => {
        $($("tbody")).css('cursor', 'pointer');
      }, 3000);
      setTimeout(() => {
        $($("tbody")).css('cursor', 'pointer');
      }, 4000);
    });

    this.role = this.context.user.role;

    this.setState({columns: Columns({
      role: this.role,
      pendingList: () => (this.state.pendingList),
      openConfirm: (documentId) => {
        this.setState({ openConfirm: true, documentId })
      }
    })})

  }

  handleConfirm = () => {
    this.handleClose();
    var listSelectedIndex = this.state.propsToolbarSelected.selectedRows.data.map(e => e.index);
    var listItens = this.state.propsToolbarSelected.displayData
      .filter(e => !(listSelectedIndex).includes(e.dataIndex))
      .map(e => e.data);
    var listRemovidos = this.state.propsToolbarSelected.displayData
      .filter(e => (listSelectedIndex).includes(e.dataIndex))
      .map(e => e.data);

    this.state.propsToolbarSelected.setSelectedRows([]);
    this.state.propsToolbarSelected.params.setState({
      itens: listItens,
      itensTable: listItens,
      itensRemovidos: listRemovidos
    });

    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    listRemovidos.forEach(element => {
      Compliance_controller.remove(token, element[0]);
    });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOpenModel() {
    this.setState({
      openModel: true,
      tipo: 'Adicionar',
      titulo: '',
      descricao: '',
      lancamento: new Date(),
      termino: new Date(),
      arquivo: '',
      arquivoName: '',
      arquivoIndicacao: null,
      arquivoIndicacaoNome: null,
      arquivoIndicacaoDisplay: true,
      editFileMode: true,
    });
  }

  handleCloseModel() {
    this.setState({ openModel: false });
  }

  UNSAFE_componentWillMount() {
    this.permissions = this.context.user.permissions;
    this.setState({ selectableRows: this.permissions["admin-compliance"] });

    //carregamento de dados nos campos
    this.loadData();
    if (this.permissions["admin-compliance"]) {
      this.setState({
        customToolbar: () => <CustomToolbar {...this} />,
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) =>
          <CustomToolbarSelect
            selectedRows={selectedRows}
            displayData={displayData}
            setSelectedRows={setSelectedRows}
            params={this}
          />,
        onRowClick: (rowData, rowMeta) => {
          this.handleOpenModel();
          this.loadDataOne(rowData[0]);
        },
      });
    } else {
      this.setState({
        onRowClick: (rowData, rowMeta) => {
          const cookies = new Cookies();
          const token = cookies.get('User-Token');
          const url = `${Config.URL_BACKEND}/compliance/${token}/${rowData[0]}`;
          window.open(url, "_blank");
        },
      });
    }
  }

  async loadDataOne(id) {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    try {
      this.setState({
        isLoading: true,
        tipo: 'Editar',
      });
      const r_compliance = await Compliance_controller.getOne(token, id);
      const j_r_compliance = JSON.parse(r_compliance.body);
      if (r_compliance.res.statusCode == 200) {
        const dt_lancamento = moment(j_r_compliance.dt_lancamento, "DD/MM/YYYY");
        const dt_termino = moment(j_r_compliance.dt_termino, "DD/MM/YYYY");
        this.setState({
          id: id,
          titulo: j_r_compliance.nm_titulo,
          descricao: j_r_compliance.ds_compliance,
          lancamento: new Date(dt_lancamento),
          termino: new Date(dt_termino),
          editFileMode: false,
          isLoading: false,
          arquivoTipo: j_r_compliance.doc_tipo,
          arquivoExtensao: j_r_compliance.doc_extensao
        });

        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:compliance',
        //       eventAction: 'callback',
        //       eventLabel: `sucesso:${id}`,
        //     }
        // });
      } else {
        if (
          j_r_compliance.status == false &&
          j_r_compliance.message &&
          j_r_compliance.message.includes("Token inválido!")
        ) {
          this.child.current.retorno('Autentificação inválida!', 'error');
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        } else {
          throw new Error("Campos necessários, não foram retornados pelo servidor!");
        }
      }

      //auditoria
      var str = "Efetuada requisição para recuperação de dados de compliance! "
        + "Response:( Method: " + r_compliance.res.request.method
        + ", StatusCode: " + r_compliance.res.statusCode
        + ", Body: (limited 100chars)" + r_compliance.body.substr(0, 100)
        + " )";
      Log.info(token, str);
    } catch (error) {
      this.child.current.retorno('Erro ao carregar dados!', 'error');
      var errorString = "Erro ao carregar dados!";
      if (Config.DEBUG === "TRUE")
        errorString = error.message;
      this.setState({
        isError: true,
        isLoading: false,
        error: errorString
      });

      // TagManager.dataLayer({
      //     dataLayer: {
      //       event: 'event',
      //       eventCategory: 'tokstok:fornecedores:compliance',
      //       eventAction: 'callback',
      //       eventLabel: `erro:${error.message}`,
      //     }
      // });

      //auditoria
      var str = "Erro na recuperação de dados de compliance! "
        + "Error:( Message: " + error.message + ", Stack: " + error.stack + " )";
      Log.error(token, str);
      console.error(error);
    }

  }

  async loadData() {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    try {
      const r_compliance = await Compliance_controller.getAll(token, cookies.get('User-Code'));
      const j_r_compliance = (JSON.parse(r_compliance.body)).data.DocumentsList;
      if (r_compliance.res.statusCode == 200) {
        this.setState({
          itens: j_r_compliance
        });
        let array = [];
        let pendingList = [];
        j_r_compliance.forEach(element => {
          const signatureDate = moment(element.signatureDate, 'DD/MM/YYYY hh:mm:ss').format('DD/MM/YYYY')
          let arrayPush = null;
          if (this.permissions['admin-compliance']) {
            arrayPush = [
              element.complianceId,
              element.complianceName,
              element.complianceDescription,
              element.startDate,
              element.endDate,
              signatureDate === 'Data inválida' ? element.signatureDate : signatureDate
            ];
            array.push(arrayPush);
            if (element.isPending) pendingList.push(element.complianceId)
          } else {
            const dt_inicio = moment(element.startDate, 'DD/MM/YYYY');
            const dt_fim = moment(element.endDate, 'DD/MM/YYYY');
            if (moment(new Date()) >= dt_inicio && moment(new Date()) <= dt_fim) {
              arrayPush = [
                element.complianceId,
                element.complianceName,
                element.complianceDescription,
                element.startDate,
                element.endDate,
                signatureDate === 'Data inválida' ? element.signatureDate : signatureDate
              ];
              array.push(arrayPush);
              if (element.isPending) pendingList.push(element.complianceId)
            }
          }
        });
        this.setState({
          itensTable: array,
          isLoading: false,
          pendingList
        });

        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:compliance',
        //       eventAction: 'callback',
        //       eventLabel: 'sucesso:lista-compliances',
        //     }
        // });
      } else {
        if (
          j_r_compliance.status == false &&
          j_r_compliance.message &&
          j_r_compliance.message.includes("Token inválido!")
        ) {
          this.child.current.retorno('Autentificação inválida!', 'error');
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        } else {
          throw new Error("Campos necessários, não foram retornados pelo servidor!");
        }
      }

      //auditoria
      var str = "Efetuada requisição para recuperação de dados de compliance! "
        + "Response:( Method: " + r_compliance.res.request.method
        + ", StatusCode: " + r_compliance.res.statusCode
        + ", Body: (limited 100chars)" + r_compliance.body.substr(0, 100)
        + " )";
      Log.info(token, str);
    } catch (error) {
      this.child.current.retorno('Erro ao carregar dados!', 'error');
      var errorString = "Erro ao carregar dados!";
      if (Config.DEBUG === "TRUE")
        errorString = error.message;   
      this.setState({
        isError: true,
        isLoading: false,
        error: errorString
      });

      // TagManager.dataLayer({
      //     dataLayer: {
      //       event: 'event',
      //       eventCategory: 'tokstok:fornecedores:compliance',
      //       eventAction: 'callback',
      //       eventLabel: `erro:${error.message}`,
      //     }
      // });

      //auditoria
      var str = "Erro na recuperação de dados de compliance! "
        + "Error:( Message: " + error.message + ", Stack: " + error.stack + " )";
      Log.error(token, str);
      console.error(error);
    }

  }

  validacoes() {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    try {
      //validações
      if (this.state.titulo === '')
        throw new Error("Preencha o campo titulo!");

      if (this.state.titulo.length > 50)
        throw new Error("Campo titulo não pode ter mais de 50 caracteres!");

      if (this.state.titulo.match(/\t/))
        throw new Error("Caracteres inválidos em campo titulo!");

      if (this.state.descricao.length > 250)
        throw new Error("Campo descrição não pode ter mais de 250 caracteres!");

      if (this.state.descricao === '')
        throw new Error("Preencha o campo descrição!");

      if (this.state.descricao.match(/\t/))
        throw new Error("Caracteres inválidos em campo descricao!");

      if (this.state.lancamento === '' || this.state.lancamento === null)
        throw new Error("Preencha o campo data de inicio da vigência!");

      if (this.state.termino === '' || this.state.termino === null)
        throw new Error("Preencha o campo data de fim da vigência!");

      if (
        (this.state.arquivo === '' || this.state.arquivo === null) &&
        this.state.arquivoIndicacao == null &&
        this.state.tipo == "Adicionar"
      )
        throw new Error("Adicione um arquivo!");

      return true;

    } catch (error) {
      this.child.current.retorno(error.message, 'warning');

      //auditoria
      var str = "Alerta na validação do formulário de " + this.state.title + "! "
        + "Warning:( Message: " + error.message + ", Stack: " + error.stack + " )";
      Log.warning(token, str);

      return false;
    }
  }

  async envioDados(formData) {
    //chama cookie para declarar token
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    const userCode = cookies.get('User-Code');

    formData.append('userId', userCode)

    let str, result = null;

    try {

      //envio de dados
      if (this.state.tipo === 'Adicionar')
        result = await Compliance_controller.post(token, formData);
      else
        result = await Compliance_controller.put(token, formData, this.state.id);

      // TagManager.dataLayer({
      //     dataLayer: {
      //         event: 'event',
      //         eventCategory: 'tokstok:fornecedores:compliance',
      //         eventAction: 'callback',
      //         eventLabel: 'sucesso:arquivo-enviado',
      //     }
      // });

      //auditoria
      str = "Efetuada requisição de envio de dados de " + this.state.title + "s! "
        + "Response:( Method: " + this.state.method
        + ", StatusCode: " + result.status
        + " )";
      Log.info(token, str);

      //checa o tipo de retorno
      if (result.status === 200) {
        var t = "adicionado";
        if (this.state.tipo != "Adicionar")
          t = "editado";

        const capitalizeFirstLetter = `${this.capitalizeFirstLetter(this.state.title)} ${t} com sucesso!`;
        this.child.current.retorno(capitalizeFirstLetter, 'success');
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        const retorno = `Não foi possível ${this.state.tipo.toLowerCase()} o ${this.state.title}!`;
        this.child.current.retorno(retorno, 'error');
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }

    } catch (error) {
      // TagManager.dataLayer({
      //     dataLayer: {
      //         event: 'event',
      //         eventCategory: 'tokstok:fornecedores:compliance',
      //         eventAction: 'callback',
      //         eventLabel: `erro:${error.message}`,
      //     }
      // });

      //auditoria
      str = "Erro ao recuperar dados de " + this.state.title + "s! "
        + "Erro:( Message: " + error.message + ", Stack: " + error.stack + " )";
      Log.error(token, str);
    }
  }

  async sendForm() {
    //chama cookie para declarar token
    const cookies = new Cookies();
    const token = cookies.get('User-Token');
    let str = null;

    try {
      //declaracao de variaveis auxiliares
      const formData = new FormData();

      //validações
      if (!this.validacoes())
        return null;

      //faz captura de arquivo no campo
      if (
        this.state.editFileMode &&
        document.querySelector('input[type="file"]') != null &&
        document.querySelector('input[type="file"]').files.length != 0
      ) {
        const file = document.querySelector('input[type="file"]').files[0];
        if (this.state.tipo === 'Adicionar') {
          const  base64 = await this.toBase64(file);
          formData.append("Doc", base64.split(",")[1]);
          formData.append("tipo", file.type);
          formData.append("extensao", file.name.split(".")[1]);
        } else {
          formData.append("file", file);
        }
      } else if (this.state.arquivo != "") {
        formData.append("Doc", this.state.arquivo);
        formData.append("tipo", this.state.arquivoTipo);
        formData.append("extensao", this.state.arquivoExtensao);
      }

      //carrega parametros enviados no body
      if (this.state.tipo === 'Adicionar') {
        formData.append("nm_titulo", this.state.titulo);
        formData.append("ds_compliance", this.state.descricao);
        formData.append("dt_lancamento", dateFormat(this.state.lancamento, "dd/mm/yyyy"));
        formData.append("dt_termino", dateFormat(this.state.termino, "dd/mm/yyyy"));
      } else { 
        formData.append("nmTitulo", this.state.titulo);
        formData.append("dsCompliance", this.state.descricao);
        formData.append("dtLancamento", dateFormat(this.state.lancamento, "dd/mm/yyyy"));
        formData.append("dtTermino", dateFormat(this.state.termino, "dd/mm/yyyy"));
      }

      //mostra loader
      this.setState({ isLoading: true });

      //envio de dados
      await this.envioDados(formData);

      // TagManager.dataLayer({
      //     dataLayer: {
      //       event: 'event',
      //       eventCategory: 'tokstok:fornecedores:compliance',
      //       eventAction: 'callback',
      //       eventLabel: `sucesso:${this.state.titulo}`,
      //     }
      // });
    } catch (error) {

      // TagManager.dataLayer({
      //     dataLayer: {
      //       event: 'event',
      //       eventCategory: 'tokstok:fornecedores:compliance',
      //       eventAction: 'callback',
      //       eventLabel: `erro:${error.message}`,
      //     }
      // });

      //auditoria
      str = "Erro ao recuperar dados de " + this.state.title + "s!"
        + "Erro:( Message: " + error.message + ", Stack: " + error.stack + " )";
      Log.error(token, str);
    }

  }

  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>{`${process.env.REACT_APP_TITLE} - Compliance`}</title>
        </Helmet>
        <Lista {...this} />
        <Alerta ref={this.child} />
        <ModalRemove ref={this.inputRef} pai={this} />
        <DialogConfirmRemove {...this} />
        <Modal {...this} />
        <DialogConfirm
          open={this.state.openConfirm} onClose={() => { this.setState({ openConfirm: false }) }}
          linkToGo={'/document-signature/' + this.state.documentId} buttonName={'continuar'}
          title={'Aceite do termo de condições gerais'}
          message={'Indicamos que o aceite do termo seja feito em conjunto com o representante legal da empresa.'} />
      </div>
    );
  }

}